import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth' // opsional: animasi smooth scroll
      };
    }
    return { x: 0, y: 0 };
  }
});

export default router;

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register', '/forgot-password','/resend-email','/term-condition', '/privacy-policy-statement','/payment','/maintenance'];
  console.log(to.path);
  if(process.env.VUE_APP_MAINTENANCE == 1 && to.path != "/maintenance"){
    return next('/maintenance');
  }
  else{
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('token');

    if (authRequired && !loggedIn) {
      return next('/login');
    }  
  }
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('token');

  if (authRequired && !loggedIn) {
    return next('/login');
  }
  // localStorage.removeItem("token");

  next();
})
